import axios from "axios";
import { getIdToken } from "firebase/auth";
import { LocalStorageConstants } from "../constants/LocalStorageConstants";
import { getSelectedOrganization } from "../helpers/localStorage";
import iframeStore from "../pages/IframeNew/iframe-store.tsx";
import migrationIframeStore from "../pages/migration-iframe-store.tsx";
import { isPlaygroundRoute } from "../utils";
import { isMigrationIframe } from "../utils/migrationIframe.ts";
import { showErrorToast } from "../utils/toast";
import { ENV_VARS } from "./env";
import { firebaseAuth } from "./firebase.ts";

export const ERRORS_TO_EXCLUDE = [
	"The dataset should have between 20 and 200 images. Please adjust the number of images to fit within this range.",
	"Failed to upload due to low resolution. Please upload images with a minimum resolution of 256x256 pixels.",
	"Failed to upload image",
	"The dataset should have between 10 and 20 images. Please adjust the number of images to fit within this range.",
	"Query doesn't stand with Bria's ethic rules",
	"Transfer organization ownership to delete your account",
];

export async function BriaAxios(
	customHeaders = {},
	signal?: AbortSignal,
	hideToastError?: boolean,
	customBaseUrl?: string,
) {
	const isIframe = iframeStore.isIframe();
	const migrationSessionJwtToken = isMigrationIframe() && migrationIframeStore.jwtToken;
	const authorization = migrationSessionJwtToken
		? migrationSessionJwtToken
		: firebaseAuth.currentUser
			? await getIdToken(firebaseAuth.currentUser)
			: iframeStore.isPreview() && iframeStore.userJwtToken
				? iframeStore.userJwtToken
				: undefined;
	const selectedOrg = getSelectedOrganization();
	const instance = axios.create({
		baseURL: customBaseUrl ? customBaseUrl : ENV_VARS.VITE_PLATFORM_API_URL,
		withCredentials: true,
		headers: {
			...((isIframe || migrationSessionJwtToken) && authorization ? { Authorization: authorization } : {}),
			...(isIframe ? { "Iframe-Id": iframeStore.iframe?.id } : {}),
			"Org-Id": selectedOrg?.organization?.uid,
			"Content-Type": "application/json",
			...customHeaders,
		},
		signal,
	});

	instance.interceptors.request.use((config) => {
		const ipProjectId = localStorage.getItem(LocalStorageConstants.IP_PROJECT_ID);
		if (ipProjectId && isPlaygroundRoute()) {
			config.headers = config.headers || {};
			(config.headers as any)["ip-project-id"] = ipProjectId;
		} else if (config.headers && (config.headers as any)["ip-project-id"]) {
			delete (config.headers as any)["ip-project-id"];
		}
		return config;
	});

	instance.interceptors.response.use(null, (error) => {
		if (axios.isCancel(error)) {
			console.log("Request canceled:", error.message);
		} else if (error.code !== "ERR_CANCELED") {
			const errorMessage = error?.response?.data?.message ?? undefined;
			const expectedError =
				error.response &&
				((error.response.status >= 400 && error.response.status < 500) || error.response.status === 504);

			if (
				!hideToastError &&
				!expectedError &&
				!ERRORS_TO_EXCLUDE.includes(errorMessage) &&
				!iframeStore.isPreview() &&
				!(error.response && error.response.status === 403)
			) {
				showErrorToast(undefined, "123");
			}
		}

		return Promise.reject(error);
	});
	return instance;
}

export type BackendError = {
	message: string;
	status: number;
	isWarning?: boolean;
};
